/*
 * Consiglio taglia (snippets/size-finder.liquid).
 * Stima petto/vita/fianchi da altezza, peso e forma del corpo (slider, con anteprima della figura), li confronta con la tabella
 * della guida taglie e salva il risultato nel browser per consigliarlo su tutti i prodotti.
 */
(function () {
  if (window.sizeFinderLoaded) return;
  window.sizeFinderLoaded = true;

  var STORAGE_KEY = 'fc-size-profile';

  // Misure del corpo in cm per taglia italiana. Si modificano da Impostazioni tema > Consiglio taglia;
  // questi valori servono solo se l'impostazione manca o non è leggibile.
  var DEFAULT_TABLE = [
    { size: '36', bust: 76, waist: 57, hips: 84 },
    { size: '38', bust: 80, waist: 61, hips: 88 },
    { size: '40', bust: 84, waist: 65, hips: 92 },
    { size: '42', bust: 88, waist: 69, hips: 96 },
    { size: '44', bust: 92, waist: 73, hips: 100 },
    { size: '46', bust: 96, waist: 77, hips: 104 },
    { size: '48', bust: 100, waist: 81, hips: 108 },
    { size: '50', bust: 104, waist: 85, hips: 112 },
    { size: '52', bust: 108, waist: 89, hips: 116 },
    { size: '54', bust: 112, waist: 93, hips: 120 }
  ];

  // Corporatura di riferimento: 165 cm, 58 kg -> taglia di riferimento (default 42)
  var REF_BODY = { height: 165, weight: 58 };
  var SIZE_TABLE = DEFAULT_TABLE;
  var REF = { height: 165, weight: 58, bust: 88, waist: 69, hips: 96 };

  // "42: 88 / 69 / 96" per riga -> [{ size, bust, waist, hips }]
  function parseTable(text) {
    var rows = String(text || '').split(/\r?\n/).map(function (line) {
      var match = line.match(/^\s*([^:]+?)\s*:\s*(\d+(?:[.,]\d+)?)\s*\/\s*(\d+(?:[.,]\d+)?)\s*\/\s*(\d+(?:[.,]\d+)?)\s*$/);
      if (!match) return null;
      var num = function (v) { return parseFloat(v.replace(',', '.')); };
      return { size: match[1], bust: num(match[2]), waist: num(match[3]), hips: num(match[4]) };
    }).filter(Boolean);
    rows.sort(function (a, b) { return a.bust - b.bust; });
    return rows.length >= 2 ? rows : null;
  }

  function configure(strings) {
    SIZE_TABLE = parseTable(strings.table) || DEFAULT_TABLE;
    var refRow = SIZE_TABLE.filter(function (row) { return row.size === String(strings.reference || '').trim(); })[0] ||
      SIZE_TABLE[Math.floor((SIZE_TABLE.length - 1) / 2)];
    REF = { height: REF_BODY.height, weight: REF_BODY.weight, bust: refRow.bust, waist: refRow.waist, hips: refRow.hips };
  }
  // Slider forma: da -2 (più stretto) a +2 (più ampio), 2 cm per scatto
  var SHAPE_STEP_CM = 2;
  var FIT_CM = { tight: -2, regular: 0, loose: 2 };

  function loadProfile() {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return data && data.v === 2 ? data : null;
    } catch (e) {
      return null;
    }
  }

  function saveProfile(profile) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
    } catch (e) {}
  }

  // Le circonferenze crescono circa con la radice di peso/altezza; la vita cambia di più col peso
  function estimateBody(input) {
    var ratio = Math.sqrt((input.weight / input.height) / (REF.weight / REF.height));
    var fit = FIT_CM[input.fit] || 0;
    return {
      bust: REF.bust * ratio + input.bust * SHAPE_STEP_CM + fit,
      waist: REF.waist * Math.pow(ratio, 1.3) + input.waist * SHAPE_STEP_CM + fit,
      hips: REF.hips * ratio + input.hips * SHAPE_STEP_CM + fit
    };
  }

  // Indice della prima taglia che veste la misura (1 cm di tolleranza)
  function sizeIndexFor(zone, cm) {
    for (var i = 0; i < SIZE_TABLE.length; i++) {
      if (SIZE_TABLE[i][zone] >= cm - 1) return i;
    }
    return SIZE_TABLE.length - 1;
  }

  function computeSizes(input) {
    var body = estimateBody(input);
    var top = Math.max(sizeIndexFor('bust', body.bust), sizeIndexFor('waist', body.waist));
    var bottom = Math.max(sizeIndexFor('waist', body.waist), sizeIndexFor('hips', body.hips));
    return { top: SIZE_TABLE[top].size, bottom: SIZE_TABLE[bottom].size };
  }

  function sizeForCategory(profile, category) {
    if (category === 'top') return profile.top;
    if (category === 'bottom') return profile.bottom;
    // Capi interi: la taglia più grande tra sopra e sotto
    return Number(profile.top) >= Number(profile.bottom) ? profile.top : profile.bottom;
  }

  /*
   * Figura femminile stilizzata (viewBox 0 0 100 210, piedi a y=205).
   * Profilo destro come [altezza relativa 0-1, semi-larghezza alla taglia 42 / 165 cm];
   * l'altezza scala la figura, peso e forma allargano busto, vita e fianchi.
   */
  var FIGURE = {
    outer: [[.115, 3], [.14, 3.4], [.165, 9.4], [.195, 12.2], [.235, 12.1], [.28, 13.2], [.32, 11.2], [.39, 10],
      [.47, 14], [.52, 15], [.6, 12.6], [.74, 7.6], [.82, 7.8], [.955, 4.2], [1, 5.6]],
    inner: [[1, 1.2], [.955, 1.6], [.82, 2.2], [.74, 1.8], [.6, 1.2], [.55, 0]],
    zones: { bust: 5, waist: 7, hips: 9 }
  };

  // Curva morbida (Catmull-Rom -> Bézier) attraverso i punti
  function smoothPath(points) {
    var d = 'M' + points[0][0].toFixed(1) + ' ' + points[0][1].toFixed(1);
    for (var i = 0; i < points.length - 1; i++) {
      var p0 = points[i - 1] || points[i];
      var p1 = points[i];
      var p2 = points[i + 1];
      var p3 = points[i + 2] || p2;
      d += ' C' + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + ' ' + (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) +
        ' ' + (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + ' ' + (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) +
        ' ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    }
    return d + ' Z';
  }

  function figureGeometry(input) {
    var cx = 50;
    var feet = 205;
    var h = input.height;
    var scale = h / REF.height;
    var ratio = Math.sqrt((input.weight / input.height) / (REF.weight / REF.height));
    // Quanto si allarga ogni punto del profilo
    // Spalle e gambe cambiano meno col peso; busto, vita e fianchi seguono anche gli slider forma
    var widen = function (index, base) {
      var w = base * scale * ratio;
      if (index <= 3) w = base * scale * Math.pow(ratio, .4);
      if (index >= 4 && index <= 5) w += input.bust * 1.1;
      if (index >= 6 && index <= 7) w = base * scale * Math.pow(ratio, 1.3) + input.waist * 1.1;
      if (index >= 8 && index <= 10) w += input.hips * (index === 10 ? .8 : 1.3);
      if (index >= 11) w = base * scale * Math.pow(ratio, .8);
      return Math.max(w, 1);
    };
    var y = function (t) { return feet - h * (1 - t); };
    var right = FIGURE.outer.map(function (pt, i) { return [cx + widen(i, pt[1]), y(pt[0])]; });
    var innerRight = FIGURE.inner.map(function (pt) { return [cx + pt[1] * scale * Math.min(ratio, 1.15), y(pt[0])]; });
    var innerLeft = innerRight.slice(0, -1).reverse().map(function (pt) { return [2 * cx - pt[0], pt[1]]; });
    var left = right.slice().reverse().map(function (pt) { return [2 * cx - pt[0], pt[1]]; });
    var zones = {};
    Object.keys(FIGURE.zones).forEach(function (zone) {
      var pt = right[FIGURE.zones[zone]];
      zones[zone] = { x1: 2 * cx - pt[0] - 3, x2: pt[0] + 3, y: pt[1] };
    });
    return {
      body: smoothPath(right.concat(innerRight, innerLeft, left)),
      head: { cy: y(.065), rx: 6 * scale, ry: 7.8 * scale },
      zones: zones
    };
  }

  function SizeFinder(root) {
    this.root = root;
    this.category = root.dataset.category;
    this.strings = JSON.parse(root.querySelector('[data-sf-strings]').textContent);
    configure(this.strings);
    this.dialog = root.querySelector('[data-sf-dialog]');
    this.form = root.querySelector('[data-sf-form]');
    this.steps = root.querySelectorAll('[data-sf-step]');
    this.stepLabel = root.querySelector('[data-sf-step-label]');
    this.next = root.querySelector('[data-sf-next]');
    this.back = root.querySelector('[data-sf-back]');
    this.done = root.querySelector('[data-sf-done]');
    this.bodyPath = root.querySelector('[data-sf-body]');
    this.head = root.querySelector('[data-sf-head]');
    this.reco = root.querySelector('[data-sf-reco]');
    this.add = root.querySelector('[data-sf-add]');
    this.availability = root.querySelector('[data-sf-availability]');
    this.productForm = root.closest('form');
    this.openLabel = root.querySelector('[data-sf-open-label]');
    // Il selettore taglia è nello stesso contenitore dello snippet
    this.sizeItems = root.parentElement.querySelectorAll('ul li');
    this.current = 1;

    var self = this;
    root.querySelector('[data-sf-open]').addEventListener('click', function () { self.open(); });
    this.next.addEventListener('click', function () { self.goNext(); });
    this.back.addEventListener('click', function () { self.show(self.current - 1); });
    this.add.addEventListener('click', function () { self.addToCart(); });
    root.querySelectorAll('[data-sf-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.dialog.close(); });
    });
    this.dialog.addEventListener('click', function (e) {
      if (e.target === self.dialog) self.dialog.close();
    });
    document.addEventListener('size-finder:update', function () { self.applyProfile(); });
    this.form.querySelectorAll('input[type="range"]').forEach(function (input) {
      input.addEventListener('input', function () {
        self.updateValues();
        self.drawFigure(input.name);
      });
      input.addEventListener('change', function () { self.drawFigure(null); });
    });

    this.applyProfile();
  }

  SizeFinder.prototype.open = function () {
    var profile = loadProfile();
    if (profile) {
      ['height', 'weight', 'bust', 'waist', 'hips'].forEach(function (name) {
        this.field(name).value = profile[name];
      }, this);
      var fit = this.form.querySelector('input[data-sf-name="fit"][value="' + profile.fit + '"]');
      if (fit) fit.checked = true;
    }
    this.updateValues();
    this.drawFigure(null);
    this.show(1);
    this.dialog.showModal();
  };

  SizeFinder.prototype.show = function (step) {
    this.current = step;
    this.steps.forEach(function (el) {
      el.hidden = Number(el.dataset.sfStep) !== step;
    });
    var isResult = step === 4;
    this.back.hidden = step === 1 || isResult;
    this.next.hidden = isResult;
    this.done.hidden = !isResult;
    if (!isResult) {
      this.add.hidden = true;
      this.availability.hidden = true;
    }
    this.next.textContent = step === 3 ? this.strings.calculate : this.strings.next;
    this.stepLabel.textContent = isResult ? '' : this.strings.step.replace('[current]', step).replace('[total]', 3);
  };

  SizeFinder.prototype.updateValues = function () {
    this.form.querySelectorAll('[data-sf-value]').forEach(function (output) {
      var input = this.field(output.dataset.sfValue);
      output.textContent = input.value + ' ' + input.dataset.sfUnit;
    }, this);
  };

  // activeZone: linea tratteggiata sulla zona che si sta regolando (busto, vita, fianchi)
  SizeFinder.prototype.drawFigure = function (activeZone) {
    var geometry = figureGeometry(this.readInput());
    this.bodyPath.setAttribute('d', geometry.body);
    this.head.setAttribute('cy', geometry.head.cy.toFixed(1));
    this.head.setAttribute('rx', geometry.head.rx.toFixed(1));
    this.head.setAttribute('ry', geometry.head.ry.toFixed(1));
    this.root.querySelectorAll('[data-sf-zone]').forEach(function (line) {
      var zone = geometry.zones[line.dataset.sfZone];
      line.setAttribute('x1', zone.x1.toFixed(1));
      line.setAttribute('x2', zone.x2.toFixed(1));
      line.setAttribute('y1', zone.y.toFixed(1));
      line.setAttribute('y2', zone.y.toFixed(1));
      line.classList.toggle('is-active', line.dataset.sfZone === activeZone);
    });
  };

  SizeFinder.prototype.field = function (name) {
    return this.form.querySelector('input[name="' + name + '"]');
  };

  SizeFinder.prototype.readInput = function () {
    var form = this.form;
    var checked = function (name, fallback) {
      var input = form.querySelector('input[data-sf-name="' + name + '"]:checked');
      return input ? input.value : fallback;
    };
    return {
      height: Number(this.field('height').value),
      weight: Number(this.field('weight').value),
      bust: Number(this.field('bust').value),
      waist: Number(this.field('waist').value),
      hips: Number(this.field('hips').value),
      fit: checked('fit', 'regular')
    };
  };

  SizeFinder.prototype.goNext = function () {
    var input = this.readInput();
    if (this.current < 3) {
      this.show(this.current + 1);
      return;
    }

    var sizes = computeSizes(input);
    var profile = Object.assign({ v: 2 }, input, sizes);
    saveProfile(profile);
    this.root.querySelector('[data-sf-result="top"]').textContent = sizes.top;
    this.root.querySelector('[data-sf-result="bottom"]').textContent = sizes.bottom;
    this.show(4);
    document.dispatchEvent(new CustomEvent('size-finder:update', { detail: profile }));
    this.showAvailability(sizeForCategory(profile, this.category));
  };

  // Variante del prodotto corrente per una taglia: { input, available } o null
  SizeFinder.prototype.findVariant = function (size) {
    var found = null;
    this.sizeItems.forEach(function (li) {
      var label = li.querySelector('label');
      var input = label && label.querySelector('input');
      if (input && label.textContent.trim() === size) {
        found = { input: input, available: !input.disabled };
      }
    });
    return found;
  };

  // Nel risultato: se il capo c'è nella taglia consigliata si può aggiungere subito al carrello
  SizeFinder.prototype.showAvailability = function (size) {
    var variant = this.findVariant(size);
    var canAdd = Boolean(variant && variant.available && this.productForm);
    this.add.hidden = !canAdd;
    this.add.textContent = this.strings.addToCart.replace('[size]', size);
    this.availability.hidden = !variant || variant.available;
    this.availability.textContent = this.strings.resultSoldout.replace('[size]', size);
  };

  SizeFinder.prototype.addToCart = function () {
    var profile = loadProfile();
    var variant = profile && this.findVariant(sizeForCategory(profile, this.category));
    if (!variant || !variant.available) return;

    // Seleziona la taglia come farebbe la cliente, poi invia il form prodotto dal suo pulsante
    variant.input.checked = true;
    variant.input.dispatchEvent(new Event('change', { bubbles: true }));
    var li = variant.input.closest('li');
    if (li && li.parentElement) {
      li.parentElement.querySelectorAll('.selected').forEach(function (el) { el.classList.remove('selected'); });
      li.classList.add('selected');
    }
    var submit = this.productForm.querySelector('[type="submit"][name="add"]');
    this.add.disabled = true;
    if (this.productForm.requestSubmit) {
      this.productForm.requestSubmit(submit || undefined);
    } else {
      this.productForm.submit();
    }
  };

  SizeFinder.prototype.applyProfile = function () {
    var profile = loadProfile();
    var size = profile ? sizeForCategory(profile, this.category) : null;
    var badge = this.strings.badge;
    var variant = size ? this.findVariant(size) : null;
    var available = Boolean(variant && variant.available);

    this.sizeItems.forEach(function (li) {
      var label = li.querySelector('label');
      if (!label) return;
      var isReco = size !== null && label.textContent.trim() === size;
      li.classList.toggle('taglia-sf-reco', isReco);
      if (isReco) {
        label.setAttribute('data-sf-badge', badge);
      } else {
        label.removeAttribute('data-sf-badge');
      }
    });

    if (size) {
      this.reco.hidden = false;
      this.reco.textContent = (available ? this.strings.recommended : this.strings.recommendedSoldout).replace('[size]', size);
      this.openLabel.textContent = this.strings.edit;
    } else {
      this.reco.hidden = true;
      this.openLabel.textContent = this.strings.open;
    }
  };

  function init() {
    document.querySelectorAll('[data-size-finder]').forEach(function (root) {
      if (!root.sizeFinder) root.sizeFinder = new SizeFinder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
